<!-- <div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <div class="row">
                    <div class="col-md-4 col-lg-4">
                    </div>
                    <div class="col-md-8 col-lg-8">
                        <div class="col-md-5 col-lg-5">
                            <input type="date" [(ngModel)]="date1" class="form-control">
                        </div>
                        <div class="col-md-5 col-lg-5">
                            <input type="date" [(ngModel)]="date2" class="form-control">
                        </div>
                        <div class="col-md-2 col-lg-2">
                            <button (click)="filterByAssignedToBetweenDates()" class="btn btn-primary">search</button>
                        </div>
                    </div>
                </div>
                <table class="table table-striped" >
                    <thead>
                      <tr>
                        <th scope="col">Task SlNo</th>
                        <th scope="col">Assigned To</th>
                        <th scope="col">Description</th>
                        <th scope="col">Completed %</th>
                        <th scope="col">Status</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let filteredData of filteredData;let i = index">
                        <th scope="col">{{filteredData.taskSlNo}}</th>
                        <th scope="col">{{filteredData.assignedToUserName}}</th>
                        <th scope="col">{{filteredData.description}}</th>
                        <th scope="col">{{filteredData.completedPercentage}}%</th>
                        <th scope="col">{{filteredData.latestStatus}}</th>
                      </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div> -->



<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <div class="header-block">
            <div class="header-title">
                <p>My Tasks</p>
            </div>
            <div class="add-block">
              <select name="" id="" [(ngModel)]="option" class="form-control" (change)="getDataByStatus(option)">
                <option value="WORK_IN_PROGRESS">Work in Progress</option>
                <option value="COMPLETED">Completed</option>
              </select>
              <div class="search">
                <span>From</span>
                  <form autocomplete="off" >
                    <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="date1">
                  </form>
              </div>
              <div class="search">
                <span>To</span>
                <form autocomplete="off" >
                  <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="date2">
                </form>
            </div>
            <button (click)="filterByAssignedToBetweenDates()">search</button>

        </div>
          </div>
            <div class="row">
              <div class="col-lg-3 col-md-3 dataListStatus">
                <ul>
                  <li class="cp" (click)="filterByAssignedToBetweenDates()">ALL TASKS<span class="New">{{Total_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('NEW')">NEW <span class="New">{{NEW_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('ASSIGNED')">ASSIGNED <span class="Work-In-Progress">{{ASSIGNED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('REASSIGNED')">REASSIGNED <span class="Pending">{{REASSIGNED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('WORK_IN_PROGRESS')">WORK_IN_PROGRESS <span class="Completed">{{WORK_IN_PROGRESS_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('PENDING')">PENDING <span class="Deferred">{{PENDING_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('COMPLETED')">COMPLETED <span class="Deferred">{{COMPLETED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('DEFERRED')">DEFERRED <span class="Deferred">{{DEFERRED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('PARTIALLY_COMPLETED')">PARTIALLY_COMPLETED <span class="Deferred">{{PARTIALLY_COMPLETED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('FORCE_CLOSED')">FORCE_CLOSED <span class="Deferred">{{FORCE_CLOSED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('CLOSED')">CLOSED <span class="Deferred">{{CLOSED_tasksCount}}</span></li>
                </ul>
              </div>
              <div class="col-lg-9 col-md-9 dataList" style="margin:0;padding: 0;">
                <div class="dataList-content">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 25%;">Name</th>
                        <th style="width: 60%;">Description</th>
                        <th style="width: 15%;">Action</th>
                      </tr>
                    </thead>
                    <!-- <tbody>
                      <tr *ngFor="let task of filteredData | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                      }">
                        <td>{{task.name}}</td>
                        <td>{{task.description}}</td>
                        <td>
                          <svg xmlns="http://www.w3.org/2000/svg"   width="18" height="18" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#deleteModal"    width="18" height="18" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#exampleModalCenter"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                          </svg> 
                        </td>
                      </tr>
                    </tbody> -->
                  </table>

                  <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let task of filteredData | paginate : {
                          itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }  ;let i = index">
        
                          <p style="width: 25%;">{{task.name}}</p>
                          <p style="width: 60%;">{{task.description}}</p>
                          <p class="action-buttons" style="width: 15%;padding-left: 25px;">
                            <svg xmlns="http://www.w3.org/2000/svg"   width="18" height="18" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#deleteModal"    width="18" height="18" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                              <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#exampleModalCenter"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                            </svg> 
                          </p>
        
                    </div>
                </div>
        
        
                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
        
                <div class="loader"  *ngIf="!isLoading && filteredData.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>
        
                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                        [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
                </div>

                  <!-- <div class="pagination-block" *ngIf="filteredData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
                  <div *ngIf="filteredData.length == 0">
                    <p class="text-center">No records found.</p>
                  </div> -->
                </div>
              </div>
            </div>
        </div>
    </div>
</div>